(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lysiq", [], factory);
	else if(typeof exports === 'object')
		exports["lysiq"] = factory();
	else
		root["lysiq"] = factory();
})(self, function() {
return 